export class TweakwiseEventTag {
    constructor()
    {
        this.currentEventType = null;
    }

    init()
    {
        this.addEventListeners();
    }

    /**
     * Event listeners
     */
    addEventListeners()
    {
        // Page Impression event (lister page, search result)
        document.addEventListener('TweakwisePageImpression', (event) => {
            this.currentEventType = 'pageImpression';
            this.pageImpressionEvent(event);
        });

        // Page Impression event (others also bought)
        document.addEventListener('TweakwisePageImpressionOab', (event) => {
            this.currentEventType = 'pageImpressionOab';
            this.pageImpressionEvent(event);
        });

        // Page Impression event (complete your look)
        document.addEventListener('TweakwisePageImpressionCyl', (event) => {
            this.currentEventType = 'pageImpressionCyl';
            this.pageImpressionEvent(event);
        });

        // To measure the amount of search queries, send a search event when the search results page is displayed.
        document.addEventListener('TweakwiseSearch', (event) => {
            this.currentEventType = 'search';
            this.searchEvent(event);
        });

        // Product view event
        document.addEventListener('TweakwiseProductView', (event) => {
            this.currentEventType = 'productView';
            this.productViewEvent(event);
        });

        document.addEventListener('TweakwiseClickProduct', (event) => {
            this.currentEventType = 'itemClick';
            this.clickProductEvent(event);
        });

        document.addEventListener('TweakwiseAddToWishlist', (event) => {
            this.currentEventType = 'addtowishlist';
            this.addToWishlistEvent(event);
        });

        document.addEventListener('TweakwisePurchase', (event) => {
            this.currentEventType = 'purchase';
            this.purchaseEvent(event);
        });

        document.addEventListener('TweakwiseAddToCart', (event) => {
            this.currentEventType = 'addtocart';
            this.addToCartEvent(event);
        });
    }

    /**
     * Page impression event
     *
     * @param event
     */
    pageImpressionEvent(event)
    {
        this.pushToTweakwise('pageImpression');
    }

    /**
     * Search event
     * Track search queries
     *
     * @param event
     */
    searchEvent(event)
    {
        const query = event.detail.searchword;

        if (query) {
            this.pushToTweakwise('search', query);
        }
    }

    /**
     * Product view event
     * Track when a user views a product detail page
     *
     * @param event
     */
    productViewEvent(event)
    {
        const product = tweakwiseVariantId;

        if (product) {
            this.pushToTweakwise('productView', product);
        }
    }

    clickProductEvent(event)
    {
        const product = event.detail.product;

        if (product) {
            this.pushToTweakwise('itemClick', product);
        }
    }

    addToWishlistEvent(event)
    {
        const product = event.detail.product;

        if (product) {
            this.pushToTweakwise('addtowishlist', product);
        }
    }

    /**
     * Add to cart event
     * Track when a user adds a product to their cart
     *
     * @param element
     */
    addToCartEvent(element)
    {
        const product = event.detail.productKey;
        const price = event.detail.price;
        const quantity = event.detail.quantity;

        if (product) {
            this.pushToTweakwise('cart-add', product, price, quantity);
        }
    }

    purchaseEvent(element)
    {
        const productElements = document.querySelectorAll('.gtm-order-data-details');
        const total = parseFloat(document.querySelector('.gtm-order-data').dataset.value);
        const tax = parseFloat(document.querySelector('.gtm-order-data').dataset.tax);
        const totalWithoutTax = parseFloat((total - tax).toFixed(2));
        let items = [];

        productElements.forEach(function (element) {
            items.push(element.dataset.tweakwiseItemId);
        })

        if (items.length > 0 && totalWithoutTax > 0) {
            this.pushToTweakwise('purchase', items, totalWithoutTax);
        }
    }

    /**
     * Push data to Tweakwise
     * Implements the Tweakwise Event Tag API
     * Documentation: https://docs.tweakwise.com/reference/event-tag
     *
     * @param eventType string - Type of event
     * @param product string - Product ID or search query (optional)
     * @param price number - Product price (optional)
     * @param quantity number - Product quantity (optional)
     */
    pushToTweakwise(eventType, product = null, price = null, quantity = null)
    {
        // Check if tweakwiseLayer exists
        if (typeof window.tweakwiseLayer === 'undefined') {
            console.warn('Tweakwise Event Tag not loaded');
            return;
        }

        let tweakwiseEventType = this.currentEventType;

        switch (tweakwiseEventType) {
            case 'pageImpressionOab':
            case 'pageImpressionCyl':
                tweakwiseEventType = 'pageImpression';
                break;
        }

        // Build event data object based on event type
        let eventData = {
            event: tweakwiseEventType,
            data: {}
        };

        // Always add the request ID for all events if available
        if (typeof tweakwiseRequestId !== 'undefined' && tweakwiseRequestId) {
            eventData.data.requestId = tweakwiseRequestId;
        }

        // Add event-specific data based on event type
        switch (this.currentEventType) {
            case 'search':
                // Search event
                if (product) {
                    eventData.data.searchTerm = product;
                }
                break;

            case 'productView':
            case 'addtowishlist':
                // Product view event
                if (product) {
                    eventData.data.productKey = product;
                }
                break;

            case 'itemClick':
                // Product view event
                if (product) {
                    eventData.data.itemId = product;
                }
                break;

            case 'purchase':
                // Purchase event
                if (product && Array.isArray(product)) {
                    eventData.data.productKeys = product;
                }
                if (price !== null) {
                    eventData.data.revenue = price;
                }
                break;

            case 'addtocart':
                // Purchase event
                if (product) {
                    eventData.data.productKey = product;
                }
                if (price !== null) {
                    eventData.data.totalAmount = price;
                }
                if (quantity !== null) {
                    eventData.data.quantity = quantity;
                }
                break;

            case 'pageImpressionOab':
                if (typeof oabTweakwiseRequestId !== 'undefined' && oabTweakwiseRequestId) {
                    eventData.data.requestId = oabTweakwiseRequestId;
                }
                break;

            case 'pageImpressionCyl':
                if (typeof cylTweakwiseRequestId !== 'undefined' && cylTweakwiseRequestId) {
                    eventData.data.requestId = cylTweakwiseRequestId;
                }
                break;

            case 'pageImpression':
            default:
                // Nothing special
                break;
        }

        // Push to Tweakwise
        try {
            window.tweakwiseLayer.push(eventData);
        } catch (error) {
            console.error('Tweakwise tracking error:', error);
        }
    }
}


